// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/value-sets/common-languages.json
export const URL = 'http://alopexcare.com/fhir/ValueSet/common-languages';
export const concepts = [
    { code: 'en', display: 'English', displayUi: 'English', system: 'urn:ietf:bcp:47' },
    { code: 'es', display: 'Spanish', displayUi: 'Spanish', system: 'urn:ietf:bcp:47' },
    { code: 'zh', display: 'Chinese', displayUi: 'Chinese', system: 'urn:ietf:bcp:47' },
    { code: 'vi', display: 'Vietnamese', displayUi: 'Vietnamese', system: 'urn:ietf:bcp:47' },
    { code: 'tl', display: 'Tagalog', displayUi: 'Tagalog', system: 'urn:ietf:bcp:47' },
    { code: 'fr', display: 'French', displayUi: 'French', system: 'urn:ietf:bcp:47' },
    { code: 'ko', display: 'Korean', displayUi: 'Korean', system: 'urn:ietf:bcp:47' },
    { code: 'ar', display: 'Arabic', displayUi: 'Arabic', system: 'urn:ietf:bcp:47' },
    { code: 'ru', display: 'Russian', displayUi: 'Russian', system: 'urn:ietf:bcp:47' },
    { code: 'pt', display: 'Portuguese', displayUi: 'Portuguese', system: 'urn:ietf:bcp:47' },
    { code: 'hi', display: 'Hindi', displayUi: 'Hindi', system: 'urn:ietf:bcp:47' },
    { code: 'pl', display: 'Polish', displayUi: 'Polish', system: 'urn:ietf:bcp:47' },
    { code: 'ja', display: 'Japanese', displayUi: 'Japanese', system: 'urn:ietf:bcp:47' },
    { code: 'de', display: 'German', displayUi: 'German', system: 'urn:ietf:bcp:47' },
    { code: 'it', display: 'Italian', displayUi: 'Italian', system: 'urn:ietf:bcp:47' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
